/* eslint-disable */
import React from 'react';
import { Box, Typography } from '@mui/material';
import type { Ticket } from '../../types/release';
import { TicketBadge } from '../common/TicketBadge';

interface SL3TicketsProps {
  sl3Tickets: Ticket[];
}

export const SL3Tickets: React.FC<SL3TicketsProps> = ({ sl3Tickets }) => {
  if (sl3Tickets.length === 0) {
    return (
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          SL3 Tickets
        </Typography>
        <Box
          sx={{
            p: 3,
            textAlign: 'center',
            border: '1px dashed',
            borderColor: 'divider',
            borderRadius: 1,
            bgcolor: 'action.hover',
          }}
        >
          <Typography variant="body2" color="text.secondary">
            No SL3 tickets found for this release.
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
            Try adjusting your filters or search query.
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h6" gutterBottom>
        SL3 Tickets ({sl3Tickets.length})
      </Typography>
      
      {sl3Tickets.map((ticket) => (
        <Box key={ticket.id} sx={{ mb: 1 }}>
          <TicketBadge ticket={ticket} />
          {ticket.children && ticket.children.length > 0 && (
            <Box sx={{ ml: 4, mt: 1 }}>
              {ticket.children.map((child) => {
                // Handle simplified child objects
                const childTicket: Ticket = typeof child === 'object' && 'type' in child
                  ? child as Ticket
                  : {
                      ...child,
                      type: 'Sub-task',
                      labels: [],
                      link: `https://outsight.atlassian.net/browse/${child.id}`,
                      children: [],
                      is_late: child.is_late || false,
                      validation_issues: [],
                    };
                return <TicketBadge key={child.id} ticket={childTicket} />;
              })}
            </Box>
          )}
        </Box>
      ))}
    </Box>
  );
};
